import React from "react";

import { addDays, formatDate } from "@travellocal/utils/dateHelpers";
import { Button } from "armstrong-react";
import { ItinerarySummaryViewDay } from "./itinerarySummaryViewDay";

import "./itinerarySummaryView.scss";

interface IItinerarySummaryViewProps {
  hideTopMessage?: boolean;
  itinerary: IItinerarySummary;
  lto: ILtoSummary;
}

interface IItineraryDaySummaryExpanded extends IItineraryDaySummary {
  isExpanded?: boolean;
}

interface LocalState {
  days?: IItineraryDaySummaryExpanded[];
}

export class ItinerarySummaryView extends React.Component<IItinerarySummaryViewProps, LocalState> {
  constructor(props: IItinerarySummaryViewProps) {
    super(props);
    this.state = {
      days: this.props.itinerary.days.map(x => ({...x, expanded: false})),
    };
  }

  public render() {
    const { itinerary } = this.props;
    const isSampleItinerary = itinerary.itineraryType === ItineraryType.Sample;
    const slug = isSampleItinerary ? (itinerary as ISampleItinerarySummary).slug :
      `enquiries/${(itinerary as IEnquiryItinerarySummary).enquiryId}/itinerary/${(itinerary as IEnquiryItinerarySummary).quoteId}`;
    const startDate = isSampleItinerary ? null : (itinerary as IEnquiryItinerarySummary).startDate;

    const handleExpandStateChange = (isExpanded: boolean, dayId = -1) => {
      this.setState({ days: this.state.days.map(x => ((x.id === dayId || dayId === -1) ? {...x, isExpanded} : x ))});
    }

    return (
      <>
        <div className="itinerary-summary-controls">
          <Button
            className="secondary-button text--regular text--dark"
            onClick={() => handleExpandStateChange(true)}
          >
            <span>Expand all days</span>
          </Button>
          <span>/</span>
          <Button
            className="secondary-button text--regular text--dark"
            onClick={() => handleExpandStateChange(false)}
          >
            <span>Collapse all days</span>
          </Button>
        </div>
        <div className="itinerary-summary-view">
          {this.state.days.map((day, index) => {
            const date = startDate ? formatDate(addDays(startDate, index), "ddd Do MMM 'YY") : null;
            return <ItinerarySummaryViewDay
              key={day.id}
              day={day}
              isSampleItinerary={isSampleItinerary}
              dayIndex={index}
              date={date}
              slug={slug}
              isExpanded={day.isExpanded}
              handleExpandStateChange={handleExpandStateChange}
            />;
          })}
        </div>
      </>
    );
  }
}
